export default __webpack_public_path__ + "static/media/app-promo-nl@2x.0bcad03d.png";